    var classes = {
        toggleFaqAccordion: "toggle-faq-accordion",
        faqAccordion: "faq-accordion"
    };

    var initBindToggleClick = function() {
        $("." + classes.toggleFaqAccordion).on("click", function() {
            var accordionId = $(this).attr("accordion-id") ;

            if ( ! $(this).hasClass("active") ){
                openAllCards(accordionId);
                $(this).addClass("active");
            } else {
                closeAllCards(accordionId);
                $(this).removeClass("active");
            }

        });
    },
        openAllCards = function(aId) {
            //remove data-parent so accordion can open more than one card at a time
            $(aId +  ' .top-level').attr('data-parent', "");
            //with the above restraint gone, show all
            $(aId + ' .collapse .show').collapse('show');
            $(aId + ' .collapse').collapse('show');
        },
        closeAllCards = function(aId) {
            $(aId + ' .collapse').collapse('hide');
            $(aId + ' .collapse .show').collapse('hide');
            //todo: make behave like an accordion again
            //var accordionId = $("." + classes.toggleFaqAccordion).attr("accordion-id");
           // $(accordionId +  ' .card .top-level').attr('data-parent', accordionId);
        },
        initWatchForClose = function() {
            var accordionId = $("." + classes.toggleFaqAccordion).attr("accordion-id");

            $( accordionId + ' .top-level.collapse').on('hidden.bs.collapse', function () {

                if( 0 === $(accordionId + ' .top-level.collapse.show').length ){
                    $("." + classes.toggleFaqAccordion).removeClass("active");
                    //todo: make behave like an accordion again
                    //re-add data-parent to accordionId so functions like an accordion again...
                    $(accordionId +  ' .card .top-level.collapse').attr('data-parent', accordionId);
                }
            });
        },

        initFaqAccordion = function () {
            initBindToggleClick();
            initWatchForClose();
            console.log("I am from component 1");
        }; // initFaqAccordion()

    $(document).ready(function() {
        if ($("." + classes.toggleFaqAccordion).length) {
            initFaqAccordion();
        }
    }); // End document.ready


